// Lee el SKU que manda «Crear promo venta» y lo borra del historial al cerrar el formulario.
import { useCallback } from 'react';
import { useNavigate, useRouterState } from '@tanstack/react-router';
import { readSalePromotionPrefill, type SalePromotionPrefill } from './salePromotionPrefill';

export function useSalePromotionPrefill(): {
    prefill: SalePromotionPrefill | null;
    clear: () => void;
} {
    const state = useRouterState({ select: (router) => router.location.state });
    const navigate = useNavigate();
    const clear = useCallback(() => {
        void navigate({
            to: '.',
            search: true,
            replace: true,
            state: (prev) => ({ ...prev, salePromotionPrefill: undefined }),
        });
    }, [navigate]);
    return { prefill: readSalePromotionPrefill(state), clear };
}
